import PromptsWorkspace from '../components/prompts/PromptsWorkspace'

/** Role-scoped prompt library for every signed-in user (nav: below Memory). */
export default function PromptsPage() {
  return <PromptsWorkspace />
}
